export const SET_FORMS = "sifarish/set_forms"
export const SET_FORMS_CATEGORIES = "sifarish/set_forms_categories"
export const SET_SIFARISH_LIST = "sifarish/set_sifarish_list"
